exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_container__2oxA9 {\n  position: sticky;\n  top: 60px;\n  align-self: flex-start;\n  height: calc(100vh - 60px);\n  overflow-y: auto;\n  background-color: #0A508B; }\n\n.styles_drawer-paper__iKwcW.styles_drawer-paper__iKwcW {\n  background-color: #0A508B; }\n", ""]);

// Exports
exports.locals = {
	"container": "styles_container__2oxA9",
	"drawer-paper": "styles_drawer-paper__iKwcW",
	"drawerPaper": "styles_drawer-paper__iKwcW"
};